<template>
    <div>
        <flicking-carousel
            v-if="!disableProductOptionCarousel"
            data-cta-anchor
            :panels="quoteProducts"
            @panelClick="onPanelClick($event.idx)"
        >
            <template #panel="{ panel: quoteProduct }">
                <div
                    v-if="!quoteProduct.is_invalid"
                    class="cursor-pointer"
                    role="button"
                >
                    <div
                        v-if="quoteProduct.products[0].image_url"
                        class="quote-product-image-container px-2"
                    >
                        <img
                            :src="quoteProduct.products[0].image_url"
                            :alt="quoteProduct.products[0].name"
                            class="product-featured my-3"
                            draggable="false"
                        />
                        <i
                            class="quote-product-image-icon fa-solid fa-hand-back-point-up"
                        ></i>
                    </div>

                    <div
                        v-if="
                            quoteProduct.products.filter(
                                (prod) => prod.id !== 'discount_product'
                            ).length > 1
                        "
                        class="px-3"
                    >
                        <div class="quote-product-small-images-container">
                            <img
                                v-for="(
                                    product, productIdx
                                ) in quoteProduct.products
                                    .filter(
                                        (prod) => prod.id !== 'discount_product'
                                    )
                                    .slice(1, 6)
                                    .filter((prod) => prod.image_url)"
                                :key="productIdx"
                                :src="product.image_url"
                                :alt="product.name"
                                class="product-small"
                                draggable="false"
                            />
                        </div>

                        <h2>{{ quoteProduct.name }}</h2>

                        <p
                            v-if="
                                !quoteProduct.allows_user_assigned_price ||
                                quoteProduct.user_assigned_price
                            "
                        >
                            <span
                                class="d-block"
                                style="font-size: 1.5em"
                                v-html="
                                    $t('quoteProducts.view.price_html', {
                                        price: quoteProduct.price,
                                        currency: quoteProduct.currency_name,
                                        vat_suffix: quoteProduct.vat_suffix,
                                    })
                                "
                            ></span>
                            <small
                                v-if="
                                    quoteProduct.original_price !=
                                    quoteProduct.price
                                "
                                class="d-block"
                            >
                                <template
                                    v-if="
                                        quoteProduct.discount_valid_for_days !==
                                        null
                                    "
                                >
                                    {{
                                        $t(
                                            "quoteProducts.view.discount_info",
                                            {
                                                count: quoteProduct.discount_valid_for_days,
                                                discount: quoteProduct.discount,
                                                currency:
                                                    quoteProduct.currency_name,
                                                vat_suffix: "",
                                                days_left:
                                                    quoteProduct.discount_valid_for_days,
                                            }
                                        )
                                    }}
                                </template>
                                <template v-else>
                                    {{
                                        $t(
                                            "quoteProducts.view.original_price",
                                            {
                                                price: quoteProduct.original_price,
                                                currency:
                                                    quoteProduct.currency_name,
                                                vat_suffix: "",
                                            }
                                        )
                                    }}
                                </template>
                            </small>
                        </p>
                    </div>
                    <div v-else class="px-3">
                        <h2>
                            {{
                                quoteProduct.products[0]
                                    .name_with_prompted_value
                            }}
                        </h2>
                        <p v-if="quoteProduct.products[0].description_title">
                            {{ quoteProduct.products[0].description_title }}
                        </p>
                        <dl
                            v-if="
                                quoteProduct.products[0].specification &&
                                quoteProduct.products[0].specification.length >
                                    0
                            "
                            class="product-specification"
                        >
                            <template
                                v-for="(spec, idx) in quoteProduct.products[0]
                                    .specification"
                                :key="idx"
                            >
                                <dt>{{ spec.label }}</dt>
                                <dd>{{ spec.value }}</dd>
                            </template>
                        </dl>

                        <p
                            v-if="
                                !quoteProduct.allows_user_assigned_price ||
                                quoteProduct.user_assigned_price
                            "
                        >
                            <template
                                v-if="quoteProduct.products[0].amount == 1"
                            >
                                <span class="d-block" style="font-size: 1.5em">
                                    {{
                                        $t(
                                            "products.unit_with_price." +
                                                quoteProduct.products[0]
                                                    .price_unit,
                                            {
                                                price: quoteProduct.price,
                                                currency:
                                                    quoteProduct.currency_name,
                                                vat_suffix:
                                                    quoteProduct.vat_suffix,
                                            }
                                        )
                                    }}
                                </span>
                                <small
                                    v-if="
                                        quoteProduct.original_price !=
                                        quoteProduct.price
                                    "
                                    class="d-block"
                                >
                                    <template
                                        v-if="
                                            quoteProduct.discount_valid_for_days !==
                                            null
                                        "
                                    >
                                        {{
                                            $t(
                                                "quoteProducts.view.discount_info",
                                                {
                                                    count: quoteProduct.discount_valid_for_days,
                                                    discount:
                                                        quoteProduct.discount,
                                                    currency:
                                                        quoteProduct.currency_name,
                                                    vat_suffix: "",
                                                    days_left:
                                                        quoteProduct.discount_valid_for_days,
                                                }
                                            )
                                        }}
                                    </template>
                                    <template v-else>
                                        ({{
                                            $t(
                                                "quoteProducts.view.original_price_title"
                                            )
                                        }}:
                                        {{
                                            $t(
                                                "products.unit_with_price." +
                                                    quoteProduct.products[0]
                                                        .price_unit,
                                                {
                                                    price: quoteProduct.original_price,
                                                    currency:
                                                        quoteProduct.currency_name,
                                                    vat_suffix: "",
                                                }
                                            )
                                        }})
                                    </template>
                                </small>
                            </template>
                            <template v-else>
                                <span class="d-block" style="font-size: 1.5em">
                                    {{
                                        $t(
                                            "products.unit_with_amount_and_price." +
                                                quoteProduct.products[0]
                                                    .price_unit,
                                            {
                                                amount: quoteProduct.products[0]
                                                    .amount,
                                                price: quoteProduct.products[0]
                                                    .price,
                                                currency:
                                                    quoteProduct.products[0]
                                                        .currency_name,
                                                vat_suffix:
                                                    quoteProduct.vat_suffix,
                                            }
                                        )
                                    }}
                                </span>
                                <small
                                    v-if="
                                        quoteProduct.original_price !=
                                        quoteProduct.price
                                    "
                                    class="d-block"
                                >
                                    ({{
                                        $t("quoteProducts.view.discount_title")
                                    }}:
                                    {{
                                        $t("quoteProducts.view.discount", {
                                            discount: quoteProduct.discount,
                                            currency:
                                                quoteProduct.currency_name,
                                        })
                                    }})
                                </small>
                            </template>
                        </p>
                    </div>

                    <p v-if="quoteProduct.signable_until" class="mt-3 mb-1">
                        Giltig till och med {{ quoteProduct.signable_until }}
                    </p>
                    <p v-if="quoteProduct.is_expired" class="mb-1" role="status">Giltighetstiden har gått ut</p>

                    <button type="button" class="mt-3 btn signbuttoninline">
                        Läs mer
                    </button>
                </div>
                <div v-else class="pt-3 px-3">
                    <h3>{{ quoteProduct.name }}</h3>
                    <p>{{ $t("quoteProducts.view.no_longer_available") }}</p>
                </div>
            </template>
        </flicking-carousel>

        <template v-for="(quoteProduct, idx) in quoteProducts" :key="idx">
            <details-modal
                v-if="!quoteProduct.is_invalid"
                :id="`products-modal-${quoteProduct.id}`"
                :quote-key="quoteKey"
                :quote-product="quoteProduct"
                :quote-products="quoteProducts"
                :quote-product-add-ons="quoteProductAddOns"
                :is-signed="isSigned"
                :quote-esign-button-txt="quoteEsignButtonTxt"
                :company-image-url="companyImageUrl"
                :signable="canSignProduct(quoteProduct)"
                :hide-totals="hideTotals"
                :hide-individual-prices="hideIndividualPrices"
                @selectedForSigning="selectProductForCheckout(idx)"
                :amounts-editable="amountsEditable"
                @updatedQuoteProducts="quoteProducts = $event"
                @updatedQuoteProductsWithAddOns="
                    quoteProducts = $event[0];
                    quoteProductAddOns = $event[1];
                "
            ></details-modal>
        </template>
        <!-- Also mounted for signed quotes: the checkout boots those straight
             to a read-only verifikat, reachable via the ?verifikat=1 deep link. -->
        <quote-checkout-iframe-modal
            v-if="
                useNewCheckout &&
                (isSigned ||
                    (signable &&
                        !hasQuotePaymentOnHold &&
                        quoteProducts.some(canSignProduct)))
            "
            :quote-key="quoteKey"
            :selected-product-id="selectedQuoteProductId"
            :explicit-product-selection="explicitProductSelection"
            @closed="explicitProductSelection = false"
            selected-kind="product"
            :pending-signature="pendingVerifikat"
            :pending-order-ref="pendingOrderRef"
            :pending-ais-resume="pendingAisResume"
        ></quote-checkout-iframe-modal>

        <bank-id-modal
            v-else-if="
                signable &&
                !isSigned &&
                !hasQuotePaymentOnHold &&
                quoteProducts.some(canSignProduct)
            "
            id="bankid"
            :app-url="appUrl"
            :quote-key="quoteKey"
            :quote-products="quoteProducts"
            :initially-selected="selectedQuoteProductIdx"
            :quote-esign-desc="quoteEsignDesc"
            :sign-component-name="signComponentName"
            :sign-component-signee-name="signComponentSigneeName"
            :sign-component-signature-button-label="
                signComponentSignatureButtonLabel
            "
            :sign-component-item-description="signComponentItemDescription"
            :products-payments-method="productsPaymentsMethod"
            :products-payments-dintero-profile-id="
                productsPaymentsDinteroProfileId
            "
            :google-ads-conversion-event-targets="
                googleAdsConversionEventTargets
            "
            :meta-ads-conversion-pixel-ids="metaAdsConversionPixelIds"
            :billecta-bank-account-retrieval="billectaBankAccountRetrieval"
            :brite-account-report-retrieval="briteAccountReportRetrieval"
            :account-retrieval-provider="accountRetrievalProvider"
            @updatedQuoteProducts="quoteProducts = $event"
        >
            <template v-if="$slots['more-information-header']" #more-information-header
                ><slot name="more-information-header"></slot
            ></template>
            <template v-if="$slots['more-information-fieldset']" #more-information-fieldset
                ><slot name="more-information-fieldset"></slot
            ></template>
        </bank-id-modal>

        <!-- The page-level ask (SalesByte 2.0 design). It appears once the
             packages have been scrolled past and opens the same #bankid host
             the in-modal sign buttons target — checkout 2.0 iframe or the
             legacy modal alike. The spacer keeps it from covering the last
             content section. -->
        <template v-if="showPageCta">
            <div style="height: 6rem" aria-hidden="true"></div>
            <fixed-checkout-cta
                :label="quoteEsignButtonTxt ? quoteEsignButtonTxt : $t('sign.move_forward')"
                @activate="openCheckoutFromCta"
            ></fixed-checkout-cta>
        </template>
    </div>
</template>

<style lang="scss" scoped>
a:focus {
    outline: none;
}

img.product-featured {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: contain;
    object-position: center center;

    outline: none;
}

.quote-product-image-container {
    display: block;
    position: relative;
}

.quote-product-small-images-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -8px;
    margin-bottom: 16px;

    img {
        flex: 1 1 0px;
        min-width: 0;
        max-width: 20%;

        object-fit: contain;

        &:nth-child(n + 2) {
            margin-left: 20px;
        }
    }
}

a.no-style {
    color: inherit;

    &:hover {
        text-decoration: inherit;
    }
}

.quote-product-image-icon {
    position: absolute;
    bottom: 25%;
    right: 25%;

    color: #c4c4c5;
    text-shadow: black 1px 0 10px;

    font-size: 55px;
    transform: rotate(-38deg) scale(0.8);
    opacity: 0.7;

    animation: pulse 2.68s 5 ease-in-out;
}

@keyframes pulse {
    0% {
        transform: rotate(-38deg) scale(0.8);
        opacity: 0.7;
    }
    50% {
        transform: rotate(-38deg) scale(1);
        opacity: 0.9;
    }
    100% {
        transform: rotate(-38deg) scale(0.8);
        opacity: 0.7;
    }
}

.product-specification {
    dt,
    dd {
        display: inline;
    }

    dt:nth-child(n + 2) {
        margin-left: 2em;
    }
}
</style>

<script setup>
import { computed, nextTick, onMounted, ref } from "vue";

import DetailsModal from "./modals/details.vue";
import BankIdModal from "./modals/bankid.vue";
import FixedCheckoutCta from "../fixedCheckoutCta.vue";

const props = defineProps({
    quoteEsignDesc: { type: String, default: undefined },
    quoteEsignButtonTxt: { type: String, default: undefined },
    appUrl: { type: String, default: undefined },
    quoteKey: { type: String, default: undefined },
    initialQuoteProducts: { type: Array, default: () => [] },
    initialQuoteProductAddOns: { type: Array, default: () => [] },
    companyPdfviewUrl: { type: String, default: undefined },
    companyImageUrl: { type: String, default: undefined },
    isSigned: { type: Boolean, default: false },
    signComponentName: { type: String, required: true },
    signComponentSigneeName: { type: String, default: null },
    signComponentSignatureButtonLabel: { type: String, required: true },
    signComponentItemDescription: { type: String, default: null },
    signable: { type: Boolean, default: false },
    hasQuotePaymentOnHold: { type: Boolean, default: false },
    hideTotals: { type: Boolean, default: false },
    hideIndividualPrices: { type: Boolean, default: false },
    disableProductOptionCarousel: { type: Boolean, default: false },
    productsPaymentsMethod: { type: String, default: null },
    productsPaymentsDinteroProfileId: { type: String, default: null },
    googleAdsConversionEventTargets: { type: Array, required: true },
    metaAdsConversionPixelIds: { type: Array, required: true },
    billectaBankAccountRetrieval: { type: Object, default: null },
    briteAccountReportRetrieval: { type: Object, default: null },
    accountRetrievalProvider: { type: String, default: null },
    amountsEditable: { type: Boolean, default: false },
});

const selectedQuoteProductIdx = ref(0);
// Scoped to one checkout opening; a later general CTA must use the saved choice.
const explicitProductSelection = ref(false);

function selectProductForCheckout(idx) {
    if (!canSignProduct(quoteProducts.value[idx])) {
        return;
    }
    selectedQuoteProductIdx.value = idx;
    explicitProductSelection.value = true;
}
const quoteProducts = ref(JSON.parse(JSON.stringify(props.initialQuoteProducts)));
const quoteProductAddOns = ref(JSON.parse(JSON.stringify(props.initialQuoteProductAddOns)));
function canSignProduct(product) {
    return props.signable && !props.hasQuotePaymentOnHold && product && !product.is_invalid && product.is_signable !== false;
}
const useNewCheckout = ref(false);
const pendingVerifikat = ref(false);
const pendingOrderRef = ref(null);
const pendingAisResume = ref(false);
// Pennant 'checkout-fixed-cta', surfaced by quotes/view.blade.php. Parked off
// for now: with the flag off this CTA never renders and the legacy blade sign
// button keeps the page.
const fixedCtaEnabled = ref(false);

// The page-level CTA mirrors the modal-mount conditions: signable, unsigned,
// nothing on hold, at least one valid package to sign for.
const showPageCta = computed(
    () =>
        fixedCtaEnabled.value &&
        props.signable &&
        !props.isSigned &&
        !props.hasQuotePaymentOnHold &&
        quoteProducts.value.some(canSignProduct)
);

function openCheckoutFromCta() {
    explicitProductSelection.value = false;
    nextTick(() => window.jQuery("#bankid").modal("show"));
}
const selectedQuoteProductId = computed(() => quoteProducts.value[selectedQuoteProductIdx.value]?.id ?? null);

onMounted(() => {
    const flagMeta = document.querySelector('meta[name="checkout-iframe-enabled"]');
    const originMeta = document.querySelector('meta[name="checkout-iframe-origin"]');
    useNewCheckout.value = flagMeta?.getAttribute("content") === "1" && Boolean(originMeta?.getAttribute("content"));
    const ctaMeta = document.querySelector('meta[name="fixed-checkout-cta-enabled"]');
    fixedCtaEnabled.value = ctaMeta?.getAttribute("content") === "1";
    maybeAutoOpenCheckout();
    maybeAutoOpenVerifikat();
    maybeAutoOpenAisResume();
});

function onPanelClick(idx) {
    const quoteProduct = quoteProducts.value[idx];
    if (!quoteProduct.is_invalid) {
        window.jQuery(`#products-modal-${quoteProduct.id}`).modal("show");
    }
}

function maybeAutoOpenCheckout() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("checkout") !== "1") {
        return;
    }
    nextTick(() => window.jQuery("#bankid").modal("show"));
    params.delete("checkout");
    const query = params.toString();
    const newUrl = window.location.pathname + (query ? `?${query}` : "") + window.location.hash;
    window.history.replaceState(window.history.state, "", newUrl);
}

function maybeAutoOpenVerifikat() {
    if (!useNewCheckout.value) {
        return;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.get("verifikat") !== "1") {
        return;
    }
    // `pending=1` is the return from a BankID app-switch whose signing
    // callback may not have landed yet (SignedQuoteController). The checkout
    // opens in a "preparing your signature" state and polls its way to the
    // verifikat, so the modal opens even though this page rendered unsigned.
    const pending = params.get("pending") === "1" && !props.isSigned;
    if (!props.isSigned && !pending) {
        return;
    }
    pendingVerifikat.value = pending;
    if (pending) {
        // The BankID order the checkout's wait should watch, so a cancelled
        // order exits the wait immediately instead of running out the clock.
        pendingOrderRef.value = params.get("order_ref") || null;
    }
    nextTick(() => window.jQuery("#bankid").modal("show"));
    if (pending) {
        // One-shot: once signed, the modal reloads the page on close, and a
        // URL still carrying the pending params would re-enter the wait after
        // it is already over.
        params.delete("verifikat");
        params.delete("pending");
        params.delete("order_ref");
        const query = params.toString();
        window.history.replaceState(
            window.history.state,
            "",
            window.location.pathname + (query ? `?${query}` : "") + window.location.hash,
        );
    }
}

function maybeAutoOpenAisResume() {
    if (!useNewCheckout.value) {
        return;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.get("ais_resume") !== "1") {
        return;
    }
    // The return leg of a Brite AIS app switch (deeplink_redirect on the Brite
    // session). Reopen the checkout so it resumes the bank-details assist; a
    // quote signed in the meantime just falls back to the plain view.
    if (!props.isSigned) {
        pendingAisResume.value = true;
        nextTick(() => window.jQuery("#bankid").modal("show"));
    }
    // One-shot: a reload or share of this URL must not re-enter the resume.
    params.delete("ais_resume");
    const query = params.toString();
    window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname + (query ? `?${query}` : "") + window.location.hash,
    );
}
</script>
